// extracted by mini-css-extract-plugin
export default {"news":"Yr1ItAm_K8yFex9z7y8U","events":"rU1Ly0uKyLF0bU0UF6zF","articles":"qggmCVsTDqWJ8hbgMPA8"};